// Traducciones de footer - Español
export const footerEs = {
  titles: {
    links: 'Enlaces',
    contact: 'Contacto',
  },
  links: {
    vehicles: 'Vehículos',
    about: 'Nosotros',
    contact: 'Contacto',
  },
  rights: 'Todos los derechos reservados.',
};

